import React from 'react';

import { GRAY_50_HEX } from 'shared';

import { DEFAULT_PAGE_SIZE_OPTIONS } from './constants';
import { Pagination } from './types';
import IconButton from '../IconButton';
import Layout from '../Layout';
import Select from '../Select';
import Text from '../Text';

interface TableFooterProps {
  pageSize: number;
  handlePageSizeChange: (value: number) => void;
  currentPage: number;
  handlePageChange: (value: number) => void;
  rows: any[];
  pagination?: Pagination;
  totalCount: number;
}

const TableFooter: React.FC<TableFooterProps> = ({
  pageSize,
  handlePageSizeChange,
  currentPage,
  handlePageChange,
  rows,
  pagination,
  totalCount
}) => {
  return (
    <Layout
      style={{
        borderTop: `2px solid ${GRAY_50_HEX}`
      }}
      position="sticky"
      bottom={0}
      left={0}
      right={0}
      height={60}
      color="white"
      align="center"
      justify="space-between"
      width="100%"
      paddingX={24}
      zIndex={100}
    >
      {pagination ? (
        <>
          <Layout direction="row" gap={16}>
            <Layout align="center" gap={8}>
              <Text size="body-xs" color="gray-600">
                Items per page
              </Text>
              <Select
                size="xs"
                value={pageSize}
                onChange={({ value }) => handlePageSizeChange(value)}
                options={(pagination.pageSizeOptions || DEFAULT_PAGE_SIZE_OPTIONS).map(size => ({
                  label: size.toString(),
                  value: size
                }))}
              />
              <Layout direction="row" gap={4}>
                <Text size="body-xs" color="gray-600">
                  {`${(currentPage - 1) * pageSize + 1}-${Math.min(currentPage * pageSize, totalCount)} of`}
                </Text>
                <Text size="body-xs" color="gray-600">
                  {totalCount}
                </Text>
                <Text size="body-xs" color="gray-600">
                  items
                </Text>
              </Layout>
            </Layout>
          </Layout>
          <Layout align="center" gap={12}>
            <IconButton
              name="leftChevron"
              type="noBackground"
              onClick={() => handlePageChange(currentPage - 1)}
              size="sm"
              disabled={currentPage === 1}
              stroke={2}
            />
            <Text size="body-xs" color="gray-600">
              {currentPage} of {Math.ceil(totalCount / pageSize)}
            </Text>
            <IconButton
              name="rightChevron"
              type="noBackground"
              onClick={() => handlePageChange(currentPage + 1)}
              size="sm"
              disabled={currentPage * pageSize >= totalCount}
              stroke={2}
            />
          </Layout>
        </>
      ) : (
        <Text size="body-xs" color="gray-600">
          {rows.length} items
        </Text>
      )}
    </Layout>
  );
};

export default TableFooter;
